import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=552edee4&scoped=true&"
import script from "./WizardFooter.vue?vue&type=script&lang=js&"
export * from "./WizardFooter.vue?vue&type=script&lang=js&"
import style0 from "./WizardFooter.vue?vue&type=style&index=0&id=552edee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552edee4",
  null
  
)

export default component.exports